<template>
  <ui-modal title="New folder" :close="close">
    <ui-form-section class="mt-6">
      <ui-input @enter="form.submit()" label="Name" v-model="form.name" :error="form.errors.get('name')"></ui-input>
    </ui-form-section>
    <template #footer-primary>
      <ui-button-new tabindex="1" primary class="w-full" :loading="form.busy" @click="form.submit()">Create</ui-button-new>
    </template>
  </ui-modal>
</template>

<script>
import {Directory} from "@models";

export default {
  props: {
    refresh: Function,
    close: Function,
    filesystemId: String,
  },
  data () {
    const initialData = {
     name: ''
    }

    return {
      form: new Form(initialData, async (form) => {
        if (! form.name) {
          form.errors.errors.name = 'The name field is required.'
          return
        }

        await Directory.create(this.filesystemId, form.name).then(() => {
          this.$emit('created')
        })

        await this.refresh()

        this.close()
      })
    }
  },
  methods: {

  },
}
</script>
